export default __webpack_public_path__ + "static/media/Image3.672d7612.png";